import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box } from "@mui/joy";
import React from "react";
import "./Order_Status_Stepper.css";
import Pink_Btn from "../../../../../common/common_btn/pink_btn/Pink_Btn";
import { formatNewDate } from "../../../../../../utils/common";


export function VerticalLinearStepper({ OrderStatus }) {
  const OrderStatusIds = {
    Processing: 2,
    PickupSchedued: 3,
    Shipped: 4,
    Delivered: 5,
    Cancelled: 6,
    Returned: 7,
    Refunded: 8,
    Replaced: 9,
  };

  console.log(OrderStatus.Order_History);
  const steps = [
    {
      date: formatNewDate(OrderStatus?.createdAt, "datetime"),
      label: "Order Accepted",
      description: "Your order has been received.",
      status: "completed",
    },
    {
      date: formatNewDate(
        OrderStatus?.Order_History?.createdAt,
        "datetime"
      ),
      label: "Parcel In Processing",
      description: "Your order will be ready to pick up shortly.",
      status:
        OrderStatus?.order_status_id >= OrderStatusIds.Processing
          ? "completed"
          : "disabled",
    },
    {
      date: formatNewDate(
        OrderStatus?.Order_History?.delivery_boy_assigned,
        "datetime"
      ),
      label: "Parcel arrived in transit site",
      description: "Your order has been received at the hub.",
      status:
        OrderStatus?.order_status_id >= OrderStatusIds.PickupSchedued
          ? "completed"
          : "disabled",
    },
    {
      date: formatNewDate(
        OrderStatus?.Order_History?.itemPickedAt,
        "datetime"
      ),
      label: "Parcel on the way",
      description: "Your order is out for delivery.",
      status:
        OrderStatus?.order_status_id >= OrderStatusIds.Shipped
          ? "completed"
          : "disabled",
    },
    {
      date: formatNewDate(
        OrderStatus?.Order_History?.deliveredAt,
        "datetime"
      ),
      time: "9:00 am",
      label: "Delivered",
      description: "Your order has been delivered successfully.",
      status:
        OrderStatus?.order_status_id >= OrderStatusIds.Delivered
          ? "completed"
          : "disabled",
    },
  ];


  return (
    <Box sx={{ maxWidth: 400 }} className="stepper_box">
      <div className="simple-stepper">
        {steps.map((step, index) => (
          <div key={index} className={`step ${step.status}`}>
            <div className="circle">
              {step.status === "completed" ? (
                <FontAwesomeIcon
                  icon={faCircleCheck}
                  className="completed_step"
                />
              ) : step.status === "active" ? (
                <div className="current_step_outer_circle">
                  <div className="current_step_inner_circle"></div>
                </div>
              ) : (
                <div className="disabled_outer">
                  <div className="circle-status disabled"></div>
                </div>
              )}
            </div>
            <div
              className={`content ${step.status === "disabled" ? "disabled-content" : ""
                }`}
            >
              {index === 1 ? (
                <div className="">
                  <p
                    className={`label ${step.status === "disabled" ? "disabled-label" : ""
                      }`}
                  >
                    {step.date} <span className="time_text">{step.time}</span>
                  </p>
                  <p
                    className={`label ${step.status === "disabled" ? "disabled-label" : ""
                      }`}
                  >
                    {step.label}
                  </p>
                  <p className="description">{step.description}</p>
                </div>
              ) : index !== 1 ? (
                <div className="">
                  <p
                    className={`label ${step.status === "disabled" ? "disabled-label" : ""
                      }`}
                  >
                    {step.date} <span className="time_text">{step.time}</span>
                  </p>
                  <p
                    className={`label ${step.status === "disabled" ? "disabled-label" : ""
                      }`}
                  >
                    {step.label}
                  </p>
                  <p className="description">{step.description}</p>
                </div>
              ) : null}
            </div>
          </div>
        ))}
      </div>
    </Box>
  );
}

const Order_Status_Stepper = ({ OrderStatus, setShowStepper }) => {
  return (
    <div className="OrderProgressStepper">
      <VerticalLinearStepper OrderStatus={OrderStatus} />

      <div className="btn_holder">
        <Pink_Btn btnText={"Close"} onClick={() => setShowStepper(false)} />
      </div>
    </div>
  );
};

export default Order_Status_Stepper;
